// src/components/CookieConsent.js

import React, { useState, useEffect } from 'react';
import './CookieConsent.css';
import {
  getConsent,
  setConsent,
  loadTracking,
  isTrackingLoaded,
  onOpenCookieSettings,
} from '../utils/consent';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (!consent) {
      setIsVisible(true);
    } else if (consent === 'accepted') {
      loadTracking();
    }
  }, []);

  useEffect(() => onOpenCookieSettings(() => setIsVisible(true)), []);

  const handleAccept = () => {
    setConsent('accepted');
    loadTracking();
    setIsVisible(false);
  };

  // Een geladen GTM is niet uit te zetten; herladen zonder GTM laat het
  // intrekken van toestemming meteen gelden.
  const handleDecline = () => {
    setConsent('declined');
    setIsVisible(false);
    if (isTrackingLoaded()) window.location.reload();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <p>
          We gebruiken cookies om te zien hoe de site gebruikt wordt en om hem te verbeteren. Klik op "Accepteren" als je dat goed vindt.
        </p>
        <div className="cookie-consent-buttons">
          <button onClick={handleAccept} className="btn-accept">
            Accepteren
          </button>
          <button onClick={handleDecline} className="btn-decline">
            Weigeren
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
